import { mainStore } from './main'

export const stores = (gaApp) => {
  return {
    main: mainStore(gaApp),
  }
}
